import * as Yup from "yup";

const validEmailMessage = "Please enter a valid email address.";
const requiredMessage = "This field is required.";
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(validEmailMessage)
    .required(requiredMessage)
    .matches(emailRegex, validEmailMessage),
  phone: Yup.string()
    .required(requiredMessage)
    .length(16, "Please enter your 10 digit mobile phone number."),
  password: Yup.string()
    .required(requiredMessage)
    .min(8, "Must contain 8 or more characters")
    .matches(/[A-Z]/, "Must contain a capital letter")
    .matches(/[0-9]/, "Must contain a number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Must contain a special character"),
  confirmPassword: Yup.string()
    .oneOf(
      [Yup.ref("password"), null],
      "Your passwords don’t match. Please try again."
    )
    .required(requiredMessage),
  referralCode: Yup.string()
});
